export const ConsumerPhoneValidationResendCodeBannerInfoUat = {
  resendCodeBanner:
    'workflow.consumerPhoneValidation.validatePhoneNumber.resendCodeBanner',
}
